<template>
  <InnerView :backgroundColor="backgroundColor">
    <template #header>
      <div class="mt-1 px-1 text-primary-contrast mb-2">
        <h1 class="mb-1 text-3xl tracking-wide font-bold">
          {{ status ? $t('login.errors.title') : $t('login.welcome') }}
        </h1>
        <h2 class="text-lg font-bold">
          {{ status ? $t('login.errors.no-account') : $t('login.connect') }}
        </h2>
      </div>
    </template>
    <div class="h-full w-full flex justify-center items-center flex-col">
      <div v-if="iAdvizeStore.authLoading" class="flex flex-col items-center justify-center gap-4">
        <div>Connexion à Mayday</div>
        <FontAwesomeIcon :icon="['fas', 'spinner-third']" spin />
      </div>
      <BaseButton v-else icon="sign-in-alt" :text="$t('login.cta')" @click="handleLogin" />
    </div>
  </InnerView>
</template>

<script setup lang="ts">
import InnerView from '@commons/components/Layout/InnerView.vue'
import { COLORS } from '@commons/theme'
import { useAdminStore } from '@getmayday/vue-modules'

const configStore = useConfigStore()
const adminStore = useAdminStore()
const iAdvizeStore = useHelpdeskStore()

const { status } = storeToRefs(adminStore)

const backgroundColor = computed(() => (status.value ? COLORS.red.DEFAULT : COLORS.blue.DEFAULT))

const handleLogin = async () => {
  try {
    const data = await iAdvizeStore.login()
    if (!data) throw new Error('No data')
  } catch (e) {
    adminStore.setStatus(404)
  }
}

onMounted(() => {
  adminStore.resetStatus()
})
</script>
